<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1" style="margin-top:20px;"><a href="#/4chap1#chap1">I. A Purloined Cipher</a></p>
<p class="toc1"><a href="#/5chap2#chap2">II. A Forced Entrance</a></p>
<p class="toc1"><a href="#/6chap3#chap3">III. Shut Out By a Prison Wall</a></p>
<p class="toc1"><a href="#/7chap4#chap4">IV. The Terror Let Loose</a></p>
<p class="toc1"><span href="#/8chap5#chap5" title="Link target outside of Sample">V. A Carnival of Blood</span></p>
<p class="toc1"><span href="#/9chap6#chap6" title="Link target outside of Sample">VI. A Doubtful Safety</span></p>
<p class="toc1"><span href="#/10chap7#chap7" title="Link target outside of Sample">VII. The Inner Conflict</span></p>
<p class="toc1"><span href="#/11chap8#chap8" title="Link target outside of Sample">VIII. An Offer of Friendship</span></p>
<p class="toc1"><span href="#/12chap9#chap9" title="Link target outside of Sample">IX. The Old Ideal and the New</span></p>
<p class="toc1"><span href="#/13chap10#chap10" title="Link target outside of Sample">X. The Fate of a King</span></p>
<p class="toc1"><span href="#/14chap11#chap11" title="Link target outside of Sample">XI. The Irrevocable Vote</span></p>
<p class="toc1"><span href="#/15chap12#chap12" title="Link target outside of Sample">XII. Separation</span></p>
<p class="toc1"><span href="#/16chap13#chap13" title="Link target outside of Sample">XIII. Disturbing Insinuations</span></p>
<p class="toc1"><span href="#/17chap14#chap14" title="Link target outside of Sample">XIV. A Dangerous Acquaintance</span></p>
<p class="toc1"><span href="#/18chap15#chap15" title="Link target outside of Sample">XV. Sans Souci</span></p>
<p class="toc1"><span href="#/19chap16#chap16" title="Link target outside of Sample">XVI. An Unwelcome Visitor</span></p>
<p class="toc1"><span href="#/20chap17#chap17" title="Link target outside of Sample">XVII. Distressing News</span></p>
<p class="toc1"><span href="#/21chap18#chap18" title="Link target outside of Sample">XVIII. A Trial and a Wedding</span></p>
<p class="toc1"><span href="#/22chap19#chap19" title="Link target outside of Sample">XIX. The Barrier</span></p>
<p class="toc1"><span href="#/23chap20#chap20" title="Link target outside of Sample">XX. A Royalist Plot</span></p>
<p class="toc1"><span href="#/24chap21#chap21" title="Link target outside of Sample">XXI. A New Environment</span></p>
<p class="toc1"><span href="#/25chap22#chap22" title="Link target outside of Sample">XXII. At Home and Afield</span></p>
<p class="toc1"><span href="#/26chap23#chap23" title="Link target outside of Sample">XXIII. Return of Two Fugitives</span></p>
<p class="toc1"><span href="#/27chap24#chap24" title="Link target outside of Sample">XXIV. Burning of the Château</span></p>
<p class="toc1"><span href="#/28chap25#chap25" title="Link target outside of Sample">XXV. Escape of Two Madcaps</span></p>
<p class="toc1"><span href="#/29chap26#chap26" title="Link target outside of Sample">XXVI. A Dying Woman</span></p>
<p class="toc1"><span href="#/30chap27#chap27" title="Link target outside of Sample">XXVII. Betrayal</span></p>
<p class="toc1"><span href="#/31chap28#chap28" title="Link target outside of Sample">XXVIII. Inmates of the Prison</span></p>
<p class="toc1"><span href="#/32chap29#chap29" title="Link target outside of Sample">XXIX. Through Darkness to Light</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3TOC.vue?88fd3a9e